// Canonical permission names mirroring the backend PermissionEnum.
// Backend remains the source of truth — these are UI gates only.
export const PERMISSION = {
  DASHBOARD_ACCESS: 'dashboard.access',
  STATIONS_VIEW: 'stations.view',
  STATIONS_MANAGE: 'stations.manage',
  STATIONS_TAB_EDIT: 'stations.tab.edit',
  STATIONS_TAB_CONNECTORS: 'stations.tab.connectors',
  STATIONS_TAB_LOGS: 'stations.tab.logs',
  STATIONS_TAB_OCPP: 'stations.tab.ocpp',
  SESSIONS_VIEW: 'sessions.view',
  SESSIONS_MANAGE: 'sessions.manage',
  TRANSACTIONS_VIEW: 'transactions.view',
  USERS_VIEW: 'users.view',
  ROLES_VIEW: 'roles.view',
  ORGANIZATIONS_VIEW: 'organizations.view',
  METRICS_VIEW: 'metrics.view',
  PREMIUM_MANAGE: 'premium.manage',
  USERS_BALANCE_EDIT: 'users.balance.edit',
  NOTIFICATIONS_MANAGE: 'notifications.manage',
  SUPPORT_VIEW: 'support.view',
  SUPPORT_MANAGE: 'support.manage',
  SYSTEM_MANAGE: 'system.manage',
} as const;

export type PermissionName = (typeof PERMISSION)[keyof typeof PERMISSION];

/**
 * Returns true if the caller holds the given permission. The OWNER role
 * carries the wildcard '*' permission and short-circuits to true.
 */
export function hasPermission(
  permissions: string[] | undefined,
  name: string,
): boolean {
  if (!permissions || permissions.length === 0) return false;
  if (permissions.includes('*')) return true;
  return permissions.includes(name);
}
